import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { ErrorBoundary, initSentry } from './sentry';
import { ErrorFallback } from './components/ErrorFallback';

// Init must run before React renders so a throw during context
// construction is captured by Sentry — the ErrorBoundary below is a
// belt-and-braces fallback for render-time errors with a UI to
// recover.
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
